module.exports = __webpack_public_path__ + "img/success-with-woodpacking.1938479b.svg";